import baseBunny from "./base_lemon/img_baseBunny_lemon.jpg";
import baseBunnyP from "./base_lemon/img_baseBunny_lemon_p.jpg";

import base from "./base_lemon/img_base_lemon.jpg";
import baseP from "./base_lemon/img_base_lemon_p.jpg";

import baseBunnyCrochet from "./base_lemon/img_baseBunnyCrochet_lemon.jpg";
import baseBunnyCrochetP from "./base_lemon/img_baseBunnyCrochet_lemon_p.jpg";

import baseBunnyCrochetRattle from "./base_lemon/img_baseBunnyCrochetRattle_lemon.jpg";
import baseBunnyCrochetRattleP from "./base_lemon/img_baseBunnyCrochetRattle_lemon_p.jpg";

import baseBunnyRattle from "./base_lemon/img_baseBunnyRattle_lemon.jpg";
import baseBunnyRattleP from "./base_lemon/img_baseBunnyRattle_lemon_p.jpg";

import baseCrochet from "./base_lemon/img_baseCrochet_lemon.jpg";
import baseCrochetP from "./base_lemon/img_baseCrochet_lemon_p.jpg";

import baseCrochetRattle from "./base_lemon/img_baseCrochetRattle_lemon.jpg";
import baseCrochetRattleP from "./base_lemon/img_baseCrochetRattle_lemon_p.jpg";

import baseRattle from "./base_lemon/img_baseRattle_lemon.jpg";
import baseRattleP from "./base_lemon/img_baseRattle_lemon_p.jpg";

export default [
    {
        type: "base",
        noPostcard: base,
        withPostcard: baseP,
    },
    {
        type: "baseBunny",
        noPostcard: baseBunny,
        withPostcard: baseBunnyP,
    },
    {
        type: "baseBunnyCrochet",
        noPostcard: baseBunnyCrochet,
        withPostcard: baseBunnyCrochetP,
    },
    {
        type: "baseBunnyCrochetRattle",
        noPostcard: baseBunnyCrochetRattle,
        withPostcard: baseBunnyCrochetRattleP,
    },
    {
        type: "baseBunnyRattle",
        noPostcard: baseBunnyRattle,
        withPostcard: baseBunnyRattleP,
    },
    {
        type: "baseCrochet",
        noPostcard: baseCrochet,
        withPostcard: baseCrochetP,
    },
    {
        type: "baseCrochetRattle",
        noPostcard: baseCrochetRattle,
        withPostcard: baseCrochetRattleP,
    },
    {
        type: "baseRattle",
        noPostcard: baseRattle,
        withPostcard: baseRattleP,
    }
]